import Navbar from "../../components/Navbar";
import { Helmet } from "react-helmet-async";
import Footer from "../../components/Footer";

const Datenschutz = () => {
  return (
    <div>
      <Helmet>
        <title>Datenschutz | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/datenschutz" />
      </Helmet>
      <Navbar />
      <main style={{ padding: "1rem" }}>
        <h1>Datenschutzerklärung</h1>

        <h2>1. Verantwortlicher</h2>
        <p>
          <strong>Name:</strong> Jörg Thome <br />
          <strong>Adresse:</strong> Grübchenstraße 48, 66839 Schmelz, Deutschland <br />
          <strong>Telefon:</strong> +49 6887 894429 <br />
          <strong>E-Mail:</strong> elektro_thome@yahoo.de
        </p>

        <h2>2. Erhebung und Speicherung personenbezogener Daten</h2>
        <p>
          Wir erheben und verarbeiten personenbezogene Daten (z. B. Name, E-Mail-Adresse, Telefonnummer),
          wenn Sie unser Kontaktformular nutzen oder uns per E-Mail kontaktieren. Diese Daten werden 
          ausschließlich zur Bearbeitung Ihrer Anfrage verwendet.
        </p>

        <h2>3. Zweck und Rechtsgrundlage der Verarbeitung</h2>
        <p>
          Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO 
          (Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen) oder aufgrund unseres berechtigten 
          Interesses nach Art. 6 Abs. 1 lit. f DSGVO, Ihnen eine bestmögliche Nutzererfahrung 
          auf unserer Webseite zu ermöglichen.
        </p>

        <h2>4. Weitergabe von Daten</h2>
        <p>
          Ihre Daten werden nicht an Dritte weitergegeben, es sei denn, dies ist gesetzlich vorgeschrieben 
          oder für die Erfüllung unseres Vertrags mit Ihnen erforderlich.
        </p>

        <h2>5. Speicherdauer</h2>
        <p>
          Wir speichern Ihre personenbezogenen Daten nur so lange, wie dies zur Bearbeitung Ihrer Anfrage 
          oder zur Erfüllung gesetzlicher Pflichten erforderlich ist.
        </p>

        <h2>6. Ihre Rechte</h2>
        <p>
          Sie haben das Recht auf:
          <ul>
            <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
            <li>Berichtigung falscher Daten (Art. 16 DSGVO)</li>
            <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          </ul>
          Zur Wahrnehmung Ihrer Rechte können Sie uns jederzeit per E-Mail unter <a href="mailto:elektro_thome@yahoo.de">elektro_thome@yahoo.de</a> kontaktieren.
        </p>

        <h2>7. Cookies</h2>
        <p>
          Unsere Webseite verwendet <strong>keine</strong> Cookies für Tracking- oder Werbezwecke.
          Falls Sie externe Dienste (z. B. Google Maps) nutzen, kann es sein, dass diese eigene Cookies setzen.
        </p>

        <h2>8. Änderungen dieser Datenschutzerklärung</h2>
        <p>
          Diese Datenschutzerklärung kann von Zeit zu Zeit aktualisiert werden, um rechtliche Anforderungen 
          oder Änderungen unserer Dienstleistungen zu berücksichtigen. Die aktuelle Version finden Sie stets 
          auf unserer Webseite.
        </p>
      </main>
      <Footer />
    </div>
  );
};

export default Datenschutz;
